import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const playCompareAnimation = () => {
  gsap.registerPlugin(ScrollTrigger);
  gsap
    .timeline({
      scrollTrigger: {
        scroller: '.compare-main-content',
        trigger: '.content-scroll',
        start: 'top',
        end: '10%',
        toggleActions: 'play none none reverse',
        // markers: true,
      },
    })
    .to(
      '.img-container',
      {
        maxHeight: 0,
      },
      0,
    )
    .to(
      '.chromecast-title',
      {
        paddingTop: '48px',
      },
      0.2,
    )
    .to(
      '.remote-img',
      {
        autoAlpha: 0,
      },
      0.2,
    );
};
